(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-main-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
 const button=event.target.closest('.option3-expand');
 document.querySelectorAll('.option3-expand').forEach(other=>{if(other!==button){other.setAttribute('aria-expanded','false');other.parentElement.classList.remove('option3-open');}});
 if(!button)return;
 const item=button.parentElement;
 const open=button.getAttribute('aria-expanded')!=='true';
 button.setAttribute('aria-expanded',String(open));
 item.classList.toggle('option3-open',open);item.classList.toggle('option3-closed',!open);
});
document.addEventListener('pointerover',event=>{const item=event.target.closest('.navigation-main > .option3-closed');if(item&&!item.contains(event.relatedTarget))item.classList.remove('option3-closed');});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.option3-expand').forEach(button=>{button.setAttribute('aria-expanded','false');button.parentElement.classList.remove('option3-open');button.parentElement.classList.add('option3-closed');});}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["velduro-order"] && !Shopify.designMode) return;
  try {
    (() => {
  const guidance = document.querySelector('.velduro-order');
  const section = guidance && guidance.closest('[id^="shopify-section-"]');
  if (!section) return;
  const formSelector = 'product-form form[action*="/cart/add"]';
  const initial = section.querySelector(formSelector + ' input[name="id"]');
  if (!initial) return;
  const initialVariant = initial.value;
  let timer;
  section.addEventListener('change', (event) => {
    if (!event.target.closest('variant-selects, variant-radios')) return;
    clearTimeout(timer);
    timer = setTimeout(() => {
      const current = section.querySelector(formSelector + ' input[name="id"]');
      if (!current || !/^\d+$/.test(current.value) || current.value === initialVariant) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', current.value);
      window.location.replace(url.toString());
    }, 1200);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yeti-supplier-availability"] && !Shopify.designMode) return;
  try {
    (() => {
    const refresh = () => {
      document.querySelectorAll('[data-yeti-supplier-date]').forEach((element) => {
        const expiry = Date.parse(element.dataset.expiresAt);
        if (!Number.isFinite(expiry) || expiry <= Date.now()) {
          const fresh = element.querySelector('[data-yeti-fresh]');
          const stale = element.querySelector('[data-yeti-stale]');
          if (fresh && !fresh.hidden) fresh.hidden = true;
          if (stale && stale.hidden) stale.hidden = false;
        }
      });
    };
    refresh();
    new MutationObserver(refresh).observe(document.documentElement, {childList: true, subtree: true});
    window.setInterval(refresh, 60000);
    document.addEventListener('visibilitychange', refresh);
  })();
  } catch(e) { console.error(e); }
})();

})();
